import { getDefaultEnergyLabel } from '@hb/modules/global/global.constants';
import { MortgageCalculationService } from '@hb/services/mortgage-calculation/mortgage-calculation.service';
import { StoreService } from '@hb/services/store/store.service';

import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AmortisationType, EnergyLabel, FixedRatePeriod, MortgageDetail, Property } from '@ap/ap-interface-apix-hypotheken-berekening';
import { ApContentModule } from '@ap/content';
import { ApErrorModule } from '@ap/error';
import { ApSpinnerComponent } from '@ap/spinner';

@Component({
    selector: 'disclaimer',
    templateUrl: './disclaimer.component.html',
    styleUrls: ['./disclaimer.component.scss'],
    standalone: true,
    imports: [CommonModule, ApContentModule, ApErrorModule, ApSpinnerComponent]
})
export class DisclaimerComponent {
    @Input() mortgageDetails: MortgageDetail;

    protected readonly storeService = inject(StoreService);
    protected readonly mortgageCalculationService = inject(MortgageCalculationService);

    getFixedRatePeriodKey(): string {
        return `global.fixed-rate-period.${FixedRatePeriod.TEN}.option`;
    }

    getAmortisationTypeKey(): string {
        return `global.amortisation-type.${AmortisationType.ANNUITY}.option`;
    }

    getEnergyLabelKey(): string {
        return this.mapToContentKey(this.storeService?.getState()?.property);
    }

    private mapToContentKey(property: Property): string {
        switch (property?.energy_label) {
            case EnergyLabel.APPPP10YR:
                return this.getContentKey('apppp10yr');
            case EnergyLabel.APPPP:
                return this.getContentKey('apppp');
            case EnergyLabel.APPP:
                return this.getContentKey('appp');
            case EnergyLabel.APP:
                return this.getContentKey('app');
            case EnergyLabel.AP_APP:
                return this.getContentKey('ap_app');
            case EnergyLabel.A:
                return this.getContentKey('a');
            case EnergyLabel.B:
                return this.getContentKey('b');
            case EnergyLabel.C_D:
                return this.getContentKey('c_d');
            case EnergyLabel.E_F_G:
                return this.getContentKey('e_f_g');
            default:
                return this.getContentKey(getDefaultEnergyLabel(property?.property_type));
        }
    }

    getContentKey(energyLabel: string): string {
        return `global.energy-label-${energyLabel}.option`;
    }
}
